import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TypographyLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_11_2_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),

  Header1("typography_3"),
  Instruction("typography_4"),
  // TODO: src/static/activity/11-2-A/0_ko.png 에 "상황 -> 경험 꾸러미" 이미지 추가 필요. 현재는 mock placeholder.
  // 배포 임시: mock 이미지 주석 처리, text instruction 만 노출
  // InstructionWithImage("typography_5", "0"),
  Instruction("typography_5"),
  Instruction("typography_6"),

  InstructionWithContent(`typography_7`, [
    [
      ButtonGroup(
        [
          { text: "A. 머릿속을 스쳐가는 부정적인 '생각'" },
          { text: "B. 불안하고 초조한 '감정'" },
          { text: "C. 도망치고 싶어지는 '충동'" },
          { text: "D. 실수를 저지른 객관적인 '상황'" },
        ],
        { id: "quiz", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz", answerIndex: 3 }],
    }),
  ]),

  Instruction("typography_8"),

  Header1("typography_9"),
  Instruction("typography_10"),
  Instruction("typography_11"),

  InstructionWithContent(`typography_12`, [
    ...LineWithSolidLabel("생각", TypographyLine("typography_bundle_thought")),
    ...LineWithSolidLabel("감정", TypographyLine("typography_bundle_emotion")),
    ...LineWithSolidLabel(
      "신체 반응",
      TypographyLine("typography_bundle_body")
    ),
    ...LineWithSolidLabel(
      "행동/충동",
      TypographyLine("typography_bundle_action")
    ),
  ]),

  Header1("typography_13"),
  Instruction("typography_14"),
  Instruction("typography_15"),
  Instruction("typography_16"),

  ...LastCard,
];
